import {
  CreateContextProvider,
  SaveButton,
  SimpleForm,
  TextInput,
  Title,
  useCreateController,
} from "react-admin";
import { PageTopBreadcrumb } from "../../components/PageTopBreadcrumb";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";

// O campo ID (desabilitado e sempre vazio) saiu da criação: o
// identificador é gerado pelo banco e aparece na ficha depois de salvar.
export const UserRoleStatusCreate = (props: any) => {
  const controller: any = useCreateController({
    resource: "user-role-status/crud",
  });
  return (
    <CreateContextProvider value={controller}>
      <Title title="Status de Cargos e Funções" />
      {/* toolbar={false}: Salvar no topo, na linha do breadcrumb */}
      <SimpleForm toolbar={false}>
        <PageTopBreadcrumb
          title="Status de Cargos e Funções"
          firstPath="/#/user-role-status/crud"
          secondTitle="Novo"
          actions={<SaveButton label="Salvar" />}
        />
        <Card sx={{ padding: 2, marginBottom: 3, width: "100%" }}>
          <CardHeader title="Criar Novo" />
          <CardContent>
            <Grid container spacing={0.5}>
              <Grid item xs={12} lg={12}>
                <TextInput
                  source="name"
                  label="Nome"
                  fullWidth
                  helperText={false}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </SimpleForm>
    </CreateContextProvider>
  );
};
